import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceUnderscore'
})
export class ReplaceUnderscorePipe implements PipeTransform {

  transform(text: string): string {

    return text.replace(new RegExp('_', 'g'), ' ');
  }

}
